import { render, staticRenderFns } from "./agreement3.vue?vue&type=template&id=fa7c92f8&scoped=true&"
import script from "./agreement3.vue?vue&type=script&lang=js&"
export * from "./agreement3.vue?vue&type=script&lang=js&"
import style0 from "./agreement3.vue?vue&type=style&index=0&id=fa7c92f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa7c92f8",
  null
  
)

export default component.exports